import { render } from "./UINoItems.vue?vue&type=template&id=66156c08"
import script from "./UINoItems.vue?vue&type=script&lang=ts"
export * from "./UINoItems.vue?vue&type=script&lang=ts"
script.render = render

export default script